import React, { useState } from 'react';
import './Downloads.css';
import product_img_menu from '../../data/product_img_menu';
import PdfIcon from '@components/PdfIcon';

// Hårdkodade dokument i sektion 1
const documents = [
  { name: 'Uthyrningsvillkor', file: '/downloads/uthyrningsvillkor.pdf' },
  { name: 'Radiotillstånd', file: '/downloads/radiotillstand.pdf' },
  // Lägg till fler här
];



// Hämta alla unika nedladdningslänkar från produktdatan
const getAllDownloads = () => {
  const seen = new Set();
  const all = [];

  product_img_menu.forEach((product) => {
    if (!product.downloadable_link) return;
    product.downloadable_link.forEach((dl) => {
      if (!dl.d_link || dl.d_link === '#' || seen.has(dl.d_link)) return;
      seen.add(dl.d_link);
      all.push({
        heading: dl.d_heading || 'Okänd fil',
        link: dl.d_link,
      });
    });
  });

  return all;
};

const isManual = (heading) =>
  heading.toLowerCase().includes('manual') ||
  heading.toLowerCase().includes('user guide');

const Downloads = () => {
  const allDownloads = getAllDownloads();
  const manuals = allDownloads.filter((d) => isManual(d.heading));
  const datasheets = allDownloads.filter((d) => !isManual(d.heading));

  const [showAll, setShowAll] = useState(false);
  const visibleManuals = showAll ? manuals : manuals.slice(0, 20);

  return (
    <div className="downloads-container">
      <div className="downloads-content">
        <h1 className="downloads-title">Nedladdningar</h1>
        <p className="downloads-intro">
          Här hittar du dokument, manualer och datablad för nedladdning.
        </p>

        {/* Sektion 1: Dokument */}
        <section className="downloads-section">
          <h2>Dokument</h2>
          <ul className="downloads-list">
            {documents.map((doc) => (
              <li key={doc.file}>
                <a
                  href={process.env.PUBLIC_URL + doc.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="downloads-link"
                >
                  <PdfIcon />
                  <span>{doc.name}</span>
                </a>
              </li>
            ))}
          </ul>
        </section>

        <div className="downloads-divider" />

        {/* Sektion 2: Manualer */}
        <section className="downloads-section">
          <h2>Manualer <span className="downloads-count">({manuals.length})</span></h2>
          {manuals.length === 0 ? (
            <p className="downloads-status">Inga manualer hittades.</p>
          ) : (
            <>
              <ul className="downloads-list">
                {visibleManuals.map((dl) => (
                  <li key={dl.link}>
                    <a
                      href={process.env.PUBLIC_URL + '/' + dl.link.replace(/^\.\//, '')}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="downloads-link"
                    >
                      <PdfIcon />
                      <span>{dl.heading}</span>
                    </a>
                  </li>
                ))}
              </ul>
              {manuals.length > 20 && (
                <button
                  className="downloads-show-more"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? 'Visa färre' : `Visa alla ${manuals.length} manualer`}
                </button>
              )}
            </>
          )}
        </section>

        <div className="downloads-divider" />

        {/* Sektion 3: Datablad och övrigt */}
        <section className="downloads-section">
          <h2>Datablad & ritningar <span className="downloads-count">({datasheets.length})</span></h2>
          {datasheets.length === 0 ? (
            <p className="downloads-status">Inga datablad hittades.</p>
          ) : (
            <ul className="downloads-list">
              {datasheets.map((dl) => (
                <li key={dl.link}>
                  <a
                    href={process.env.PUBLIC_URL + '/' + dl.link.replace(/^\.\//, '')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="downloads-link"
                  >
                    <PdfIcon />
                    <span>{dl.heading}</span>
                  </a>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
};

export default Downloads;
